import 'normalize.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import './index.scss';
import '@/initialize';

import ReactDOM                 from 'react-dom/client';
import App                      from '@/App';
import authStore                from '@widesk-core/stores/authStore';
import cookie                   from '@widesk-core/tools/cookie';
import devToolbarStore          from '@widesk-core/stores/devToolbarStore';
import * as Sentry              from '@sentry/react';
import { canReloadForNewBuild } from '@/helpers/staleBuild';
import { reloadForNewBuild }    from '@/helpers/staleBuild';

// L'authentification est partagée avec le site public via des cookies posés sur le
// domaine racine commun (ex. .tokamap.com) : on lit la session depuis les cookies
// plutôt que le localStorage. Arriver sur le studio depuis le site public déjà
// connecté suffit alors à être authentifié, sans transmettre de token dans l'URL.
// Les noms sont préfixés : d'autres projets posent leurs propres cookies `token` sur le même domaine.
const SESSION_COOKIE_PREFIX = 'tokamap_';
authStore.setStorage({
	getItem: key => cookie.getItem(SESSION_COOKIE_PREFIX + key),
	setItem: (key, value) => cookie.setItem(SESSION_COOKIE_PREFIX + key, value),
	removeItem: key => cookie.removeItem(SESSION_COOKIE_PREFIX + key),
});

Sentry.init({
	enabled: !__LOCAL__,
	dsn: "https://b0f173625eb9a38fecc0bb7105fbd506@o240489.ingest.us.sentry.io/4511376336617472",
	integrations: [
		new Sentry.BrowserTracing({
			tracePropagationTargets: ['localhost', /^https:\/\/.+tokamap/],
		}),
		new Sentry.Replay(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

window.addEventListener('vite:preloadError', event => {
	if (canReloadForNewBuild()) {
		event.preventDefault();
		reloadForNewBuild();
	}
});

if (__LOCAL__) {
	const _error = console.error;
	// Affichage d'un message pour chaque erreur dans la console
	console.error = function () {
		// eslint-disable-next-line prefer-rest-params
		const args = arguments;
		const message = Array.prototype.slice.apply(args).join(' ');
		// setTimeout : évite de muter l'observable de façon synchrone pendant un rendu React
		// (un console.error peut survenir en plein render, ce qui déclenchait un setState
		// sur DevToolbar pendant le rendu d'un autre composant)
		setTimeout(() => devToolbarStore.addConsoleError(message));
		return _error.apply(console, args as any);
	};
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	// Désactivation de React.StrictMode car cela déclenche plusieurs fois les requêtes
	// ce qui entraine des dysfonctionnements avec les resolvable

	// <React.StrictMode>
	<App />,
	// </React.StrictMode>,
);
